import React from 'react';
import classNames from 'classnames';

import './Badge.scss';

export interface IBadgeProps {
  children?: React.ReactNode;
  className?: string;
  text?: string;
  halfOpacity?: boolean;
}

export const Badge = ({ children, className, text, halfOpacity }: IBadgeProps) => (
  <span className={classNames('Badge d-flex', className, { 'half-opacity': halfOpacity })}>
    {text && <span className="Badge-text">{text}</span>}
    {children}
  </span>
);

Badge.defaultProps = {
  children: undefined,
  className: undefined,
  text: undefined,
  halfOpacity: false,
};
